module.exports = __webpack_public_path__ + "img/gzh.05f4d817.png";